import React from "react";
import { waUrl } from "../lib/constants";

export const LocationColumn = ({ title, location, items, testId, message }) => {
    const href = waUrl(
        message ||
            `Hi Aditya, I'd like to reserve a session at ${location} (${title}).`,
    );
    return (
        <div
            data-testid={testId}
            style={{
                border: "1px solid rgba(201,162,39,0.15)",
                padding: "40px 32px",
                display: "flex",
                flexDirection: "column",
                gap: 18,
                backgroundColor: "rgba(255,255,255,0.01)",
            }}
        >
            <div>
                <p
                    className="eyebrow"
                    style={{ marginBottom: 8, color: "#c9a227" }}
                >
                    {title}
                </p>
                <h3
                    className="font-serif"
                    style={{
                        color: "#ffffff",
                        fontSize: 26,
                        fontWeight: 500,
                        lineHeight: 1.2,
                    }}
                >
                    {location}
                </h3>
            </div>
            <ul
                style={{
                    listStyle: "none",
                    padding: 0,
                    margin: "8px 0 24px",
                    display: "flex",
                    flexDirection: "column",
                    gap: 0,
                }}
            >
                {items.map((it, idx) => (
                    <li
                        key={idx}
                        style={{
                            color: "#ffffff",
                            fontSize: 15,
                            padding: "14px 0",
                            borderBottom:
                                idx === items.length - 1
                                    ? "none"
                                    : "1px solid rgba(255,255,255,0.06)",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <span>{typeof it === "string" ? it : it.name}</span>
                        {typeof it !== "string" && it.note && (
                            <span
                                style={{
                                    color: "#888",
                                    fontSize: 12,
                                    letterSpacing: "0.1em",
                                }}
                            >
                                {it.note}
                            </span>
                        )}
                    </li>
                ))}
            </ul>
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`${testId}-reserve-btn`}
                className="btn-gold-outline"
                style={{ alignSelf: "flex-start" }}
            >
                Reserve
            </a>
        </div>
    );
};

export default LocationColumn;
